import clsx from 'clsx';
import { Text, Title } from 'components/Typography';
import type { FC } from 'react';

interface CardCarouselHeaderProps {
  heading: string;
  subHeading: string;
}

export const CardCarouselHeader: FC<CardCarouselHeaderProps> = ({ heading, subHeading }) => {
  return (
    <div className="text-center md:mb-30">
      <Text tag="p" type="lead" className={clsx('mb-2.5')}>
        {heading}
      </Text>
      <Title tag="h2" type={'md'} className="mb-5">
        {subHeading}
      </Title>
    </div>
  );
};
